import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Product } from '../data/products';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  return <motion.div whileHover={{
    y: -5
  }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col h-full" data-id="element-143">
      <Link to={`/product/${product.slug}`} className="block relative aspect-[4/3] bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden group p-6" data-id="element-144">
        <img src={product.image} alt={product.name} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-145" />
        {product.isPopular && <div className="absolute top-4 left-4 bg-yarbo-yellow text-yarbo-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-146">
            Popular
          </div>}
      </Link>

      <div className="p-6 flex flex-col flex-grow" data-id="element-147">
        <div className="flex justify-between items-start mb-2" data-id="element-148">
          <h3 className="text-xl font-bold text-yarbo-dark leading-tight" data-id="element-149">
            <Link to={`/product/${product.slug}`} className="hover:text-yarbo-yellow transition-colors" data-id="element-150">
              {product.name}
            </Link>
          </h3>
        </div>

        <div className="text-2xl font-bold text-yarbo-dark mb-4" data-id="element-151">
          ${product.price.toLocaleString()}
          <span className="text-sm font-normal text-gray-500 ml-2 block sm:inline" data-id="element-152">
            *Editable Price Placeholder
          </span>
        </div>

        <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-153">
          {product.shortDescription}
        </p>

        <ul className="space-y-2 mb-6" data-id="element-154">
          {product.features.slice(0, 3).map((feature, idx) => <li key={idx} className="flex items-start text-sm text-gray-600" data-id="element-155">
              <Check className="w-4 h-4 text-yarbo-green mr-2 mt-0.5 flex-shrink-0" data-id="element-156" />
              <span data-id="element-157">{feature}</span>
            </li>)}
        </ul>

        <div className="mt-auto pt-4 border-t border-gray-100 flex gap-3" data-id="element-158">
          <Link to={`/product/${product.slug}`} className="flex-1 btn-secondary py-2.5 text-sm" data-id="element-159">
            View Details
          </Link>
          <Link to="/contact" className="flex-1 btn-primary py-2.5 text-sm" data-id="element-160">
            Get Quote
          </Link>
        </div>
      </div>
    </motion.div>;
}